module.exports = __webpack_public_path__ + "img/corporate-competition-2024-schedule-men-group-1.5122a12f.jpg";